import React from 'react';

const Loadable = React.lazy(() => import('../../pages/Marketing/Marketing'));

export default Loadable;
